// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  connectAuthEmulator,
  setPersistence,
  browserSessionPersistence,
  updateProfile,  // ADD THIS for updating user profile
  sendPasswordResetEmail,  // ADD THIS for password reset
} from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
  connectFirestoreEmulator,
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  connectStorageEmulator,
} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCBX-94dTbvDhdZln8LC_gtWKnbdq4i8mM",
  authDomain: "morgan-brb-fleet.firebaseapp.com",
  projectId: "morgan-brb-fleet",
  storageBucket: "morgan-brb-fleet.appspot.com",
  messagingSenderId: "602801915131",
  appId: "1:602801915131:web:2ea084347300ae68c75c5e",
  measurementId: "G-QHEVRJJF50",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Enable emulators for local development
if (window.location.hostname === "localhost") {
  console.log("Using Firebase emulators on localhost:3000");
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8080);
  connectStorageEmulator(storage, "localhost", 9199);
}

export {
  auth,
  db,
  storage,
  signInWithEmailAndPassword,
  firebaseSignOut,
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
  storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  setPersistence,
  browserSessionPersistence,
  updateProfile,  // ADDED
  sendPasswordResetEmail,  // ADDED
};